import id from 'dayjs/locale/id'

const idID = {
  calendar: {
    yearSelection: '{year}',
    monthSelection: '{month}',
    yearRadio: 'tahun',
    monthRadio: 'bulan',
    hideWeekend: 'Sembunyikan Akhir Pekan',
    showWeekend: 'Tampilkan Akhir Pekan',
    today: 'Hari Ini',
    thisMonth: 'Bulan Ini',
    week: 'Senin,Selasa,Rabu,Kamis,Jumat,Sabtu,Minggu',
    cellMonth: 'Januari,Februari,Maret,April,Mei,Juni,Juli,Agustus,September,Oktober,November,Desember'
  },
  datePicker: {
    dayjsLocale: 'id',
    placeholder: {
      date: 'Pilih tanggal',
      month: 'Pilih bulan',
      year: 'Pilih tahun',
      quarter: 'Pilih kuartal',
      week: 'Pilih minggu'
    },
    weekdays: ['Sen', 'Sel', 'Rab', 'Kam', 'Jum', 'Sab', 'Min'],
    months: ['Jan', 'Feb', 'Mar', 'Apr', 'Mei', 'Jun', 'Jul', 'Agt', 'Sep', 'Okt', 'Nov', 'Des'],
    quarters: ['Q1', 'Q2', 'Q3', 'Q4'],
    rangeSeparator: ' - ',
    direction: 'ltr',
    format: 'YYYY-MM-DD',
    dayAriaLabel: 'D',
    yearAriaLabel: 'Y',
    monthAriaLabel: 'M',
    weekAbbreviation: 'W',
    confirm: 'Konfirmasi',
    selectTime: 'Pilih Waktu',
    selectDate: 'Pilih Tanggal',
    nextYear: 'Tahun Depan',
    preYear: 'Tahun Lalu',
    nextMonth: 'Bulan Depan',
    preMonth: 'Bulan Lalu',
    preDecade: 'Dasawarsa Lalu',
    nextDecade: 'Dasawarsa Depan',
    now: 'Sekarang'
  },
  timePicker: {
    dayjsLocale: 'id',
    now: 'Sekarang',
    confirm: 'Konfirmasi',
    anteMeridiem: 'AM',
    postMeridiem: 'PM',
    placeholder: 'Pilih waktu'
  },
  // Other components can be added here if needed
  pagination: {
    itemsPerPage: '{size} / halaman',
    jumpTo: 'Pindah ke',
    page: '',
    total: 'tidak ada item | 1 item | {count} items'
  },
  cascader: {
    empty: 'Data Kosong',
    loadingText: 'memuat...',
    placeholder: 'Silakan pilih'
  },
  transfer: {
    title: '{checked} / {total}',
    empty: 'Data Kosong',
    placeholder: 'Masukkan kata kunci untuk mencari'
  },
  dialog: {
    confirm: 'Konfirmasi',
    cancel: 'Batal'
  },
  drawer: {
    confirm: 'Konfirmasi',
    cancel: 'Batal'
  },
  popconfirm: {
    confirm: {
      content: 'OK'
    },
    cancel: {
      content: 'Batal'
    }
  },
  table: {
    empty: 'Data Kosong',
    loadingText: 'memuat...',
    loadingMoreText: 'memuat lebih banyak',
    filterInputPlaceholder: '',
    sortAscendingOperationText: 'Klik untuk sortir ascending',
    sortCancelOperationText: 'Klik untuk membatalkan sortir',
    sortDescendingOperationText: 'Klik untuk sortir descending',
    clearFilterResultButtonText: 'Hapus',
    columnConfigButtonText: 'Konfigurasi Kolom',
    columnConfigTitleText: 'Konfigurasi Kolom Tabel',
    columnConfigDescriptionText: 'Silakan pilih kolom untuk ditampilkan di tabel',
    confirmText: 'Konfirmasi',
    cancelText: 'Batal',
    resetText: 'Reset',
    selectAllText: 'Pilih Semua',
    searchResultText: 'Cari "{result}". Tidak ditemukan item. | Cari "{result}". Ditemukan 1 item. | Cari "{result}". Ditemukan {count} items.'
  },
  select: {
    empty: 'Data Kosong',
    loadingText: 'memuat...',
    placeholder: 'Silakan pilih'
  },
  tree: {
    empty: 'Data Kosong'
  },
  treeSelect: {
    empty: 'Data Kosong',
    loadingText: 'memuat...',
    placeholder: 'Silakan pilih'
  },
  input: {
    placeholder: 'Silakan masukkan'
  }
}

export default idID
